import {
  type UnlayerDesign,
  type UnlayerDesignBlock,
} from "../unlayer-email-content/types/unlayer-design";

export function generateUnlayerDesign(
  header: UnlayerDesignBlock[],
  footer: UnlayerDesignBlock[],
  design: UnlayerDesignBlock[],
): UnlayerDesign {
  return {
    body: {
      id: "H1nsQM1miK",

      rows: [...header, ...design, ...footer],
      headers: [],
      footers: [],
      values: {},
    },
    counters: {},
    schemaVersion: 8,
  };
}
